// @flow

import $ from 'jquery'
import React, { Component } from 'react'
import Modal from 'react-responsive-modal'

import initializeForms from '../main/legacy/initialize.forms'
import getJson from '../services/getJson'

type Props = {|
  url: string,
  modalWidth: number,
  onClose: Function,
  onObjectCreated: Function
|}

type State = {|
  isOpen: boolean,
  html: string
|}

export default class AjaxPopup extends Component<Props, State> {
  modalContainer: any

  constructor(props: Props) {
    super(props)

    this.state = {
      isOpen: false,
      html: ''
    }
  }

  render() {
    return (
      <Modal
        open={this.state.isOpen}
        onClose={() => {
          this.props.onClose()
          this.setState({ isOpen: false })
        }}
      >
        <div style={{ maxWidth: this.props.modalWidth }}>
          <div
            ref={(el) => {
              this.modalContainer = el
            }}
            dangerouslySetInnerHTML={{ __html: this.state.html }}
          />
        </div>
      </Modal>
    )
  }

  componentDidMount() {
    this.loadContent()
  }

  loadContent() {
    const { url } = this.props

    getJson(url, {}, { async: true })
      .done((response) => this.processResponse(response))
      .fail(() => this.errorCallback())
  }

  errorCallback() {
    this.alertInternalError()
  }

  processSubformResponse(response: Object) {
    if (response.success) {
      this.closePopup()
      this.props.onObjectCreated && this.props.onObjectCreated(response)
    } else if (response.html) {
      this.showPopup(response.html)
    } else {
      this.closePopup()
    }
  }

  processResponse(response: Object) {
    if (response.success) {
      this.showPopup(response.html)
    } else {
      this.showAllert(response.error)
    }
  }

  alertInternalError() {
    this.showAllert('Internal Server error')
  }

  showAllert(message: string) {
    window.alert(message)
  }

  showPopup(html: string) {
    this.setState({ isOpen: true, html: html })
    initializeForms()
    let $form = $(this.modalContainer)
    $form.on('ajax:success', 'form[data-remote=true]', (e: Object, response: Object) =>
      this.processSubformResponse(response)
    )
    $form.on('ajax:error', 'form[data-remote=true]', () => this.errorCallback())
  }

  closePopup() {
    this.props.onClose()
    this.setState({ isOpen: false })
  }
}
